import React from "react";

const styles: Record<string, React.CSSProperties> = {
    sidebarSkeleton: {
        display: "flex",
        flexDirection: "column",
        height: "calc(100vh - 175px)",
        padding: 0,
        backgroundColor: "white"
    },
    controls: {
        flex: 1,
        listStyle: "none",
        margin: 0,
        padding: 0,
        overflow: "hidden"
    },
    skeletonItem: {
        padding: "16px 24px",
        borderBottom: "1px solid rgba(0, 0, 0, 0.06)"
    },
    skeletonActions: {
        display: "flex",
        gap: "12px",
        padding: "16px 8px 8px",
        marginBottom: "4px",
        borderTop: "1px solid rgba(0, 0, 0, 0.1)",
        justifyContent: "end" as const
    },
    skeletonLine: {
        background: "linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%)",
        backgroundSize: "200% 100%",
        borderRadius: "4px",
        animation: "skeleton-shimmer 1.4s infinite"
    },
    skeletonLabel: {
        height: "12px",
        width: "35%",
        marginBottom: "8px"
    },
    skeletonInput: {
        height: "36px",
        width: "100%"
    },
    skeletonInputTall: {
        height: "72px",
        width: "100%"
    },
    skeletonButton: {
        height: "32px",
        width: "80px",
        borderRadius: "4px"
    }
};

const shimmerKeyframes = `
@keyframes skeleton-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}`;

export default function SidebarSkeleton() {
    return (
        <>
            <style>{shimmerKeyframes}</style>
            <div style={styles.sidebarSkeleton}>
                <ul style={styles.controls}>
                    {[...Array(4)].map((_, i) => (
                        <li key={i} style={styles.skeletonItem}>
                            <div style={{ ...styles.skeletonLine, ...styles.skeletonLabel }}></div>
                            <div
                                style={{
                                    ...styles.skeletonLine,
                                    ...(i === 2 ? styles.skeletonInputTall : styles.skeletonInput)
                                }}
                            ></div>
                        </li>
                    ))}
                </ul>
                <div style={styles.skeletonActions}>
                    <div style={{ ...styles.skeletonLine, ...styles.skeletonButton }}></div>
                    <div style={{ ...styles.skeletonLine, ...styles.skeletonButton }}></div>
                </div>
            </div>
        </>
    );
}
